import { CircularProgress } from "@mui/material";
import MDBox from "components/MDBox";

const PinCodeSetupForm = (props) => {
  const { createPin, handlePinSetup, handleConfirmPinSetup, isLoadingSubmit, handleSubmit } = props;
  return (
    <form onSubmit={handleSubmit} className="pin-setup-form">
      <div className="pin-setup-field">
        <label htmlFor="pin" className="pin-setup-label">
          Enter your PIN code here
        </label>
        <input
          id="pin"
          value={createPin.pinSetup}
          onChange={handlePinSetup}
          required
          maxLength="4"
          placeholder="Numbers only (4 digits)"
          className="pin-setup-input"
          pattern="\d*"
        />
      </div>
      <div className="pin-setup-field">
        <label htmlFor="confirmPin" className="pin-setup-label">
          Confirm your PIN code again
        </label>
        <input
          id="confirmPin"
          value={createPin.confirmPinSetup}
          onChange={handleConfirmPinSetup}
          required
          maxLength="4"
          placeholder="Numbers only (4 digits)"
          className="pin-setup-input"
        />
      </div>

      <MDBox style={{ display: "flex" }}>
        <button type="submit" className="pin-setup-button" disabled={isLoadingSubmit}>
          {isLoadingSubmit ? (
            <>
              <CircularProgress size={20} color="inherit" className="spinner-icon" /> Saving...
            </>
          ) : (
            "Save"
          )}
        </button>
        {createPin.error && <p className="pin-setup-error">{createPin.error}</p>}
      </MDBox>
    </form>
  );
};

export default PinCodeSetupForm;
